import { useCallback, useEffect } from "react";

import Modal from "@vfuk/core-modal";
import { OverlayProvider } from "@vfuk/core-overlay-controller";

import { ScrollableContainerStyles } from "../ScrollableContainerStyles";
import Profile from "./Profile";
import { useProfileModal } from "./hooks/useProfileModal";

const UserModal = () => {
  const { toggle, isShown: shouldDisplay } = useProfileModal();

  const onClose = useCallback(() => toggle(), [toggle]);

  useEffect(() => {
    /**
     * force closing the Blank panel appears on left side when opening profile
     * https://jira.tools.aws.vodafone.com/browse/UC-80980
     */
    document.getElementById("side-navigation-close-button")?.click();
  }, [shouldDisplay]);

  /**
   * For some reason there is an issue with Modal if another modal is rendered
   * at the same time.
   *
   * So to prevent the modal getting stuck, we don't render this modal until
   * we need it to be open.
   *
   * Side-effect is that there won't be close animations, because the modal
   * doesn't trigger callback when animations have finished, rather it triggers it
   * when the animation starts.
   *
   * https://jira.tools.aws.vodafone.com/browse/UC-81932
   */

  if (!shouldDisplay) return null;

  return (
    <OverlayProvider>
      <Modal
        srName="user-modal"
        isOpen
        id="user-modal"
        size={4}
        side="left"
        type="flyout"
        animate
        isClosable
        onCloseCb={onClose}
      >
        <ScrollableContainerStyles>
          <Profile />
        </ScrollableContainerStyles>
      </Modal>
    </OverlayProvider>
  );
};

export default UserModal;
